function restoreInitialSurface(): void {
  document.documentElement.style.background = "#101118";
  document.body.style.background = "#101118";
  document.body.style.opacity = "1";
  document.body.style.visibility = "visible";
}

export function init(): void {
  restoreInitialSurface();
}
